// News post: Meet the New Bumpups (September 26, 2026)
import React from 'react';
import { Link } from 'react-router-dom';
import chat_asset from '../../../assets/images/blog/blog-new-bumpups-chat.jpg';
import workspace_asset from '../../../assets/images/blog/blog-new-bumpups-workspace.jpg';

const NewBumpups = () => (
  <>
    <p>
      This is our biggest update yet. Your workspace chat now <strong>remembers the whole conversation</strong>, so you can follow
      up, refine and build on every answer. And all of Bumpups has a <strong>brand-new look</strong>, designed to get you from a
      video to the answers you need with fewer clicks.
    </p>

    <h2>Chats that remember</h2>
    <p>
      Until now, every question you asked Bump AI started from scratch. Not anymore. Every chat is now a real conversation: Bump AI
      remembers what you asked and what it answered, so you can keep going the way you would with a friend who watched the video
      with you.
    </p>
    <p>
      Ask how a lecture explains the Ford Pinto case, then say <strong>“Turn that into 3 exam questions.”</strong> Have it write a
      YouTube description and suggest titles, then ask for <strong>“15 tags, most relevant first.”</strong> No copying, no pasting,
      no repeating yourself. Bump AI knows exactly what you mean.
    </p>

    <figure>
      <img src={chat_asset} alt="A workspace chat where Bump AI answers the follow-up “Now give me 15 tags, most relevant first” for a TED talk" loading="lazy" width="1600" height="1704" />
    </figure>

    <ul>
      <li><strong>Follow up, refine, build on it.</strong> Ask for a shorter version, a different tone or a whole new format, all in the same chat.</li>
      <li><strong>Watch answers arrive.</strong> Replies appear as Bump AI writes them, and any answer copies in one click.</li>
      <li><strong>Start in one tap.</strong> Not sure what to ask? Try a suggestion like “Summarize the video” or “Quiz me with 5 questions.”</li>
      <li><strong>Word-for-word quotes from your uploads.</strong> For videos you upload, Bump AI now reads the entire transcript, so quotes come back exactly as they were said.</li>
      <li><strong>10 messages for every video.</strong> Use them in one chat or split them across several, with a meter that always shows how many are left. If an answer fails, it doesn’t count.</li>
    </ul>

    <h2>A whole new look</h2>
    <p>
      We redesigned Bumpups from top to bottom. Everything is cleaner, calmer and easier to find, so you spend less time clicking
      around and more time learning from your videos.
    </p>

    <figure>
      <img src={workspace_asset} alt="The new Workspace home: a link box, a searchable grid of videos and the new sidebar" loading="lazy" width="1640" height="1125" />
    </figure>

    <ul>
      <li><strong>Workspace is your home.</strong> Sign in and you’re ready to go. Paste a YouTube link or drop a video anywhere on the page, and find every video you’ve added in one searchable grid.</li>
      <li><strong>One simple sidebar.</strong> Workspace, Creator Studio, Plans, Settings and Help all live in one place, with your remaining minutes always in view.</li>
      <li><strong>Progress you can trust.</strong> A new progress bar moves smoothly while your video is processed, and picks up right where it left off if you refresh.</li>
      <li><strong>Easier sign-in.</strong> Continue with Google or get a sign-in link by email, all on one clean screen.</li>
    </ul>

    <h2>Never miss what’s next</h2>
    <p>
      We’re shipping fast, and we don’t want you to miss a thing. Every new feature, improvement and fix now lives on our
      new <Link to="/changelog">Changelog</Link>.
    </p>
    <p>
      Open a workspace, paste a link and ask your first follow-up. We can’t wait to hear what you think!
    </p>
  </>
);

export default NewBumpups;
